{
  "version": 1,
  "asset_id": "b7a442c5-9218-492c-8436-f907522b6148",
  "project_id": "39db9d3d-7b53-4499-b84e-1b89accf167e",
  "url": "/__l5e/assets-v1/b7a442c5-9218-492c-8436-f907522b6148/family-support-cutout.webp",
  "r2_key": "a/v1/39db9d3d-7b53-4499-b84e-1b89accf167e/b7a442c5-9218-492c-8436-f907522b6148/family-support-cutout.webp",
  "original_filename": "family-support-cutout.webp",
  "size": 45938,
  "content_type": "image/webp",
  "created_at": "2026-08-18T08:35:40Z"
}
